var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyStar = function SvgEmptyStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.729 10.333 7 9l2.292 1.333-.625-2.521 1.979-1.687-2.604-.229L7 3.479 5.958 5.917l-2.604.208 2 1.667-.625 2.541Zm-1.833 2.5 1.125-4.604L.375 5.167l4.75-.396L7 .438l1.875 4.354 4.75.375-3.646 3.062 1.125 4.604L7 10.396l-4.104 2.437Z",
    fill: "#000"
  })));
};
export default SvgEmptyStar;